import { LoaderFunctionArgs } from 'react-router'

export interface GetRouteResourceIdsResult {
  companyIdFromPath: string | null
  companyIdFromQuery: string | null
  projectIdFromPath: string | null
  projectIdFromQuery: string | null
  botIdFromPath: string | null
  botIdFromQuery: string | null
}

export function getRouteResourceIds({
  request,
  params,
}: LoaderFunctionArgs): GetRouteResourceIdsResult {
  const { searchParams } = new URL(request.url)

  return {
    companyIdFromPath: params.companyId ?? null,
    companyIdFromQuery: searchParams.get('companyId'),
    projectIdFromPath: params.projectId ?? null,
    projectIdFromQuery: searchParams.get('projectId'),
    botIdFromPath: params.botId ?? null,
    botIdFromQuery: searchParams.get('botId'),
  }
}
